import classNames from 'classnames'
import { observer } from 'mobx-react'
import { useEffect, useRef, useState } from 'react'
import GlobalState from '../../stores/GlobalState'
import './index.scss'

import { ReactComponent as Play } from '../../assets/Rectangle 6.svg'
import { ReactComponent as Stop } from '../../assets/Rectangle 7.svg'
import { isMobile } from '../../hooks/detect'
import ReactPlayer from 'react-player'
import { runInAction } from 'mobx'

const VideoBox = observer(
  ({
    src,
    setShow,
    poster,
  }: {
    src: string
    setShow: () => void
    poster: string
  }) => {
    const [isPlay, setPlay] = useState(false)
    const video = useRef<any>(null)

    useEffect(() => {
      // video.current = document.querySelector('.videobox video')
      if (!video.current) return

      if (!GlobalState.video.show) {
        video.current && video.current.pause()
      }
      // if (GlobalState.video.show && isMobile) {
      //   setTimeout(() => {
      //     setPlay(false)
      //   }, 2000)
      // }
    }, [GlobalState.video.show])

    useEffect(() => {
      if (!GlobalState.video.show) {
        setPlay(false)
      }
    }, [GlobalState.video.show])

    const fullScreen = () => {
      var elem: any = video.current
      //var elem: any = document.querySelector('.videobox video')

      if (!elem) return

      if (elem.requestFullscreen) {
        elem.requestFullscreen()
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen()
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen()
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen()
      }
    }
    const playVideo = () => {
      if (!video.current) return
      if (video.current.paused) {
        const videos = document.querySelectorAll('video')
        videos.forEach((v) => {
          if (!v.paused) v.pause()
        })
        video.current.play()
        isMobile && fullScreen()
      } else {
        video.current.pause()
      }
      setPlay(!isPlay)
    }

    useEffect(() => {
      ;(video.current as HTMLVideoElement).addEventListener('playing', (e) => {
        setPlay(true)
        runInAction(() => {
          GlobalState.video.isPlay = true
        })
      })
      ;(video.current as HTMLVideoElement).addEventListener('pause', (e) => {
        setPlay(false)
        runInAction(() => {
          GlobalState.video.isPlay = false
        })
      })
    }, [])

    return (
      <section
        className={classNames(
          'videobox',
          GlobalState.video.show && 'videobox-show',
        )}
        onClick={setShow}
      >
        <div
          onClick={(e) => e.stopPropagation()}
          className="videobox__container"
        >
          <div className="videobox__close" onClick={setShow}>
            <div className="videobox__close-dash"></div>
            <div className="videobox__close-dash"></div>
          </div>
          <div className="videobox__box">
            <video
              src={GlobalState.video.src}
              poster={GlobalState.video.poster}
              autoPlay={false}
              preload={'preload'}
              controls={isPlay}
              ref={video}
            >
              <source src={GlobalState.video.src} type="video/mp4"></source>
            </video>
            <div
              className={classNames('image-wrapper__play', isPlay && 'hide')}
              onClick={playVideo}
            >
              {!isPlay ? (
                <>
                  <span>
                    <Play />
                  </span>
                </>
              ) : (
                <div className="stopMobile">
                  <Stop />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>
    )
  },
)

export default VideoBox
